import React, { Component } from 'react'
import './plans.scss'
import { Tabs, Tab } from 'react-bootstrap'


class Plans extends Component {

    render() {
        return (
            <section id="plans">
                <div className="container-fluid">
                    <div className="text-center mb-5">
                        <h5>Plans</h5>
                        <div className="section-separator"></div>
                        <div className="text mb-5">As well as consultancy, we also offer a number of consumer plans for websites, mobile apps and Alexa skills.  Please contact for more information.</div>
                        <Tabs defaultActiveKey="web" className="mb-5">
                          <Tab eventKey="web" title="Web">
                              <div className="card-container" id="web">
                                  <div className="row">
                                      <div className="col-12 col-md-4">
                                          <div className="card card-left" id="card-web-1">
                                              <h6 className="copper">Basic</h6>
                                              <div className="separator mb-5"></div>
                                              <div className="price-wrapper text-center">
                                                  <div className="from">From</div>
                                                  <span className="currency">£</span>
                                                  <span className="price">499</span>
                                              </div>

                                              <ul>
                                                  <li><b>1-5</b> pages</li>
                                                  <li><b>Mobile/tablet</b> friendly</li>
                                                  <li><b>Responsive</b> design</li>
                                                  <li><b>£10</b> per month hosting</li>
                                              </ul>
                                          </div>
                                      </div>
                                      <div className="col-12 col-md-4">
                                          <div className="card card-center" id="card-web-2">
                                              <h6 className="white">Standard</h6>
                                              <div className="separator mb-5"></div>
                                              <div className="price-wrapper text-center">
                                                  <div className="from">From</div>
                                                  <span className="currency">£</span>
                                                  <span className="price">799</span>
                                              </div>
                                              <ul>
                                                  <li><b>5-8</b> pages</li>
                                                  <li><b>Mobile/tablet</b> friendly</li>
                                                  <li><b>Responsive</b> design</li>
                                                  <li>Site <b>analytics</b></li>
                                                  <li><b>£12</b> per month hosting</li>
                                              </ul>
                                          </div>
                                      </div>
                                      <div className="col-12 col-md-4">
                                          <div className="card card-right" id="card-web-3">
                                              <h6 className="gold">Premium</h6>
                                              <div className="separator mb-5"></div>
                                              <div className="price-wrapper text-center">
                                                  <div className="from">Contact us</div>
                                                  <span className="call">Custom</span>
                                              </div>
                                              <ul>
                                                  <li><b>8+</b> pages</li>
                                                  <li><b>Mobile/tablet</b> friendly</li>
                                                  <li><b>Responsive</b> design</li>
                                                  <li>Site <b>analytics</b></li>
                                                  <li><b>£15</b> per month hosting</li>
                                              </ul>
                                          </div>
                                      </div>
                                  </div>
                                </div>
                          </Tab>
                          <Tab eventKey="mobile" title="Mobile">
                              <div className="card-container" id="mobile">
                                  <div className="row">
                                      <div className="col-12 col-md-4 plr-0">
                                          <div className="card card-left" id="card-mobile-1">
                                              <h6 className="copper">Basic</h6>
                                              <div className="separator mb-5"></div>
                                              <div className="price-wrapper text-center">
                                                  <div className="from">From</div>
                                                  <span className="currency">£</span>
                                                  <span className="price">999</span>
                                              </div>
                                              <ul>
                                                  <li><b>Android</b> or <b>iOS</b></li>
                                                  <li><b>Beautiful</b> modern design</li>
                                                  <li><b>1-5</b> screens</li>
                                                  <li><b>Deployment</b> to Play Store/iTunes</li>
                                              </ul>
                                          </div>
                                      </div>
                                      <div className="col-12 col-md-4 plr-0">
                                          <div className="card card-center" id="card-mobile-2">
                                              <h6 className="white">Standard</h6>
                                              <div className="separator mb-5"></div>
                                              <div className="price-wrapper text-center">
                                                  <div className="from">From</div>
                                                  <span className="currency">£</span>
                                                  <span className="price">1,499</span>
                                              </div>
                                              <ul>
                                                  <li><b>Android</b> or <b>iOS</b></li>
                                                  <li><b>Beautiful</b> modern design</li>
                                                  <li><b>5-10</b> screens</li>
                                                  <li><b>Deployment</b> to Play Store/iTunes</li>
                                                  <li>App <b>analytics</b></li>
                                              </ul>
                                          </div>
                                      </div>
                                      <div className="col-12 col-md-4 plr-0">
                                          <div className="card card-right" id="card-mobile-3">
                                              <h6 className="gold">Premium</h6>
                                              <div className="separator mb-5"></div>
                                              <div className="price-wrapper text-center">
                                                  <div className="from">Contact us</div>
                                                  <span className="call">Custom</span>
                                              </div>
                                              <ul>
                                                  <li><b>Android </b> and <b>iOS</b></li>
                                                  <li><b>Beautiful</b> modern design</li>
                                                  <li><b>10+</b> screens each</li>
                                                  <li><b>Social</b> sign in</li>
                                                  <li><b>Offline</b> syncing</li>
                                                  <li><b>In app purchases</b></li>
                                              </ul>
                                          </div>
                                      </div>
                                  </div>
                                </div>
                          </Tab>
                        </Tabs>
                    </div>
                    <div id="pricing-desc" className="text-center">Please note that all plans are a guideline and pricing will depend on what features you require.</div>
                </div>
            </section>
        )
    }
}

export default Plans;



// WEBPACK FOOTER //
// ./src/components/Plans/Plans.js